/**
 * Where HR powers apply.
 *
 * HR users only act as HR on HR screens: Admin (and every page mapped
 * into it - /hr/*, T&A policies, hiring settings, ...), People, Hiring,
 * Help, and Home (whose HR strip links into Admin). On the "my work"
 * screens below they're treated as their org role (manager / exec), so
 * reviewing your own team goes through the normal chain - e.g. a JD
 * change for your report routes to your manager - and HR-only buttons
 * don't show.
 *
 * The SPA sends `X-Hr-Context: on` from HR screens; the API drops the
 * HR role on every request without it (apps/api/src/lib/auth.ts).
 */
import { adminLocationForPath } from './adminGroups'

/** "My work" areas - HR users act as their org role here. */
const MY_WORK_PREFIXES = ['/team', '/roles', '/manager', '/employee', '/executive', '/time-attendance', '/comp']

export function isHrContextPath(path: string): boolean {
  if (adminLocationForPath(path)) return true
  return !MY_WORK_PREFIXES.some(p => path === p || path.startsWith(`${p}/`))
}
